<!--
  Data check (owner only, on Accounts): runs the server's read-only check of everyone's data
  (/api/admin/check, apps/api/src/liveCheck.ts) and lists every inconsistency found. "Copy report
  for Claude" copies the whole report, so Claude can verify the data itself.
-->
<script lang="ts">
  import * as C from "../settings/check.ts";
  import { fill, shows } from "../settings/index.ts";
  import { api } from "../lib/api.ts";
  import { app } from "../lib/store.svelte.ts";

  let report = $state<{ problems: { kind: string; text: string }[] } | null>(null);
  let raw = "";
  let error = $state("");
  let busy = $state(false);

  async function run() {
    busy = true;
    error = "";
    try {
      const r = await api<{ problems: { kind: string; text: string }[] }>("/api/admin/check");
      raw = JSON.stringify(r, null, 2);
      report = r;
    } catch (e) {
      error = (e as Error).message;
    } finally {
      busy = false;
    }
  }
  $effect(() => {
    void run();
  });

  async function copy() {
    try {
      await navigator.clipboard.writeText(raw);
      app.toast(C.CHECK_COPIED);
    } catch {
      app.toast(C.CHECK_COPY_FAILED, "error");
    }
  }
</script>

{#if shows(C.CHECK_TITLE)}
  <section class="check" aria-label={C.CHECK_TITLE}>
    <div class="head">
      <h2>{C.CHECK_TITLE}</h2>
      {#if report}
        <span class="pill" class:bad={report.problems.length > 0}>
          {report.problems.length ? fill(C.CHECK_PROBLEMS, { count: report.problems.length }) : C.CHECK_OK}
        </span>
      {/if}
      <span class="grow"></span>
      <button class="btn small" disabled={busy} onclick={() => void run()}>{C.CHECK_AGAIN}</button>
      <button class="btn small primary" disabled={!report} onclick={copy}>{C.CHECK_COPY}</button>
    </div>
    {#if busy && !report}<p class="muted small">{C.CHECK_RUNNING}</p>{/if}
    {#if error}<p class="owes small">{error}</p>{/if}
    {#if report?.problems.length}
      <ul>
        {#each report.problems as p, i (i)}<li>{p.text}</li>{/each}
      </ul>
    {/if}
  </section>
{/if}

<style>
  .check {
    display: grid;
    gap: 8px;
    margin: 0 0 18px;
    padding: 12px 14px;
    border-radius: var(--r-lg);
    background: var(--surface);
    box-shadow: inset 0 0 0 1px var(--rule);
  }
  .head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  h2 {
    margin: 0;
    font-size: var(--t-lg);
  }
  .grow {
    flex: 1;
  }
  .pill {
    padding: 1px 8px;
    border-radius: 999px;
    background: var(--wash);
    color: var(--ok);
    font-size: var(--t-xs);
    font-weight: 600;
  }
  .pill.bad {
    color: var(--owes);
  }
  ul {
    margin: 0;
    padding-left: 18px;
    display: grid;
    gap: 4px;
    font-size: var(--t-sm);
    color: var(--owes);
  }
  .small {
    font-size: var(--t-sm);
  }
  p {
    margin: 0;
  }
</style>
